module.exports = __webpack_public_path__ + "img/04.159cce97.png";